import { render, staticRenderFns } from "./audios.vue?vue&type=template&id=e1089bba&"
import script from "./audios.vue?vue&type=script&lang=js&"
export * from "./audios.vue?vue&type=script&lang=js&"
import style0 from "./audios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MediaSubNav: require('/app/components/media-sub-nav.vue').default,SocialShareBtns: require('/app/components/social-share-btns.vue').default,AudioBlock: require('/app/components/content-elements/audio-block.vue').default})
